import replacement from '@/api/wholesale/replacement'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  locationId: [],
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
}

export const getters = {
  getProduct: state => ({ chosenProduct, productCurrentRow } = {}) => {
    if(chosenProduct !== undefined && productCurrentRow !== undefined){
      return state.products.filter(p => 
        !_.includes(chosenProduct.filter(cp => cp.product_id != productCurrentRow).map(el => el.product_id),p.product_id)
      );
    }
    return state.products;
  },
  getUom: state => productId => {
    return state.products.filter(p => p.product_id == productId)
      .map(el => el.uom_category.unit_of_measures)
      .flat()
  },
  isDefaultUom: state => productId => {
    if(productId){
      return state.products.filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures).flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) =>  init =  value)
    }
    return null
  },
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_PRODUCT(state, data){
    state.products = data
  },
  SET_LOCATION_ID(state, data){
    state.locationId = data
  },
  CLEAR_SETUP(state){
    state.products = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.locationId,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return replacement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return replacement.store(data)
  },
  update(context, { id, data }) {
    return replacement.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await replacement.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return replacement.destroy(id)
  },
  getMainProduct(context, attribute = {}){
    return replacement.mainProduct({ params: attribute })
  },
  getEmployee(context){
    return replacement.employee()
  },
  async getReplacementProduct(context, attribute = {}){
      let response = await replacement.replacementProduct({ params: attribute })
      context.commit('SET_PRODUCT', response.data)
      return response
  }
}
